import { render, staticRenderFns } from "./goodsDialog.vue?vue&type=template&id=a433fc9a&scoped=true&"
import script from "./goodsDialog.vue?vue&type=script&lang=js&"
export * from "./goodsDialog.vue?vue&type=script&lang=js&"
import style0 from "./goodsDialog.vue?vue&type=style&index=0&id=a433fc9a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a433fc9a",
  null
  
)

export default component.exports